__webpack_require__.p = "/rest-countries-api-with-color-theme-switcher/";